import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Injectable, forwardRef, Input, HostListener, NgModule } from '@angular/core';
import * as i4$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i7 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import * as i5 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i1 from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import * as i4 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i6 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i3$1 from '@firestitch/clear';
import { FsClearModule } from '@firestitch/clear';
import * as i8 from '@firestitch/skeleton';
import { FsSkeletonModule } from '@firestitch/skeleton';
import * as i2 from '@firestitch/clipboard';
import { Subject } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { switchMap, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import * as i3 from '@angular/material/form-field';
import * as i10 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';

class DialogComponent {
    constructor(_dialogRef, _cdRef, _clipboard) {
        this._dialogRef = _dialogRef;
        this._cdRef = _cdRef;
        this._clipboard = _clipboard;
        this.zoom = 1;
        this.searchChanged = new Subject();
    }
    select(event, icon) {
        if (event.ctrlKey || event.shiftKey) {
            this._clipboard.copy(icon);
        }
        else {
            this._dialogRef.close(icon);
        }
    }
    ngOnInit() {
        const excludes = /^battery_|^signal_cellular|^signal_wifi/;
        fromFetch('/assets/fs-icons.json')
            .pipe(switchMap((response) => response.json()))
            .subscribe((data) => {
            const categories = Object.keys(data)
                .reduce((accum, item) => {
                const parts = item.split('::');
                const categoryId = parts[0];
                const icon = parts[1];
                if (!icon.match(excludes)) {
                    let category = accum[categoryId];
                    if (!category) {
                        category = {
                            name: categoryId,
                            icons: [],
                        };
                        accum[categoryId] = category;
                    }
                    category.icons.push({
                        id: icon,
                    });
                }
                return accum;
            }, {});
            this.categories = Object.keys(categories).map(e => categories[e]);
            this.data = this.categories;
            this._cdRef.markForCheck();
        });
        this._dialogRef.updateSize('5000px');
        this.searchChanged
            .pipe(debounceTime(300), distinctUntilChanged())
            .subscribe((text) => {
            this.categories = [
                ...this.data,
            ];
            if (text.length) {
                text = text.toLocaleLowerCase();
                this.categories = this.categories
                    .map((category) => {
                    return Object.assign(Object.assign({}, category), { icons: category.icons.filter((icon) => {
                            return icon.id.indexOf(text) !== -1;
                        }) });
                })
                    .filter((category) => {
                    return category.icons.length;
                });
            }
            this._cdRef.markForCheck();
        });
    }
}
DialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DialogComponent, deps: [{ token: i1.MatDialogRef }, { token: i0.ChangeDetectorRef }, { token: i2.FsClipboard }], target: i0.ɵɵFactoryTarget.Component });
DialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: DialogComponent, selector: "fs-component", ngImport: i0, template: "<mat-dialog-content>\n  <mat-form-field floatLabel=\"never\">\n    <span matPrefix><mat-icon>search</mat-icon></span>\n    <input matInput placeholder=\"Search\" [(ngModel)]=\"search\" (ngModelChange)=\"searchChanged.next($event)\">\n  </mat-form-field>\n  <ng-container *fsSkeleton=\"categories\">\n    <div *ngFor=\"let category of categories\" class=\"category\">\n      <h1>{{category.name}}</h1>\n      <div class=\"icons\">\n        <span class=\"icon\" *ngFor=\"let icon of category.icons\">\n          <a \n              [matTooltip]=\"icon.id\"\n              [matTooltipShowDelay]=\"500\"\n              href=\"javascript:;\"\n              (click)=\"select($event, icon.id)\">\n            <mat-icon>{{icon.id}}</mat-icon>\n          </a>\n        </span>\n      </div>\n    </div>\n  </ng-container>\n</mat-dialog-content>\n<div mat-dialog-actions>\n  <button mat-button mat-dialog-close color=\"primary\">Close</button>\n</div>", styles: ["h1{font-size:20px;text-transform:capitalize}.icon{display:block;width:60px;height:60px}mat-form-field{width:100%;position:sticky;top:0;background:#fff}mat-form-field ::ng-deep .mat-form-field-flex{align-items:center}mat-form-field ::ng-deep .mat-form-field-infix{border:0}.category{margin-bottom:15px}.category:last-child{margin:0}.icons{display:grid;grid-template-columns:repeat(auto-fill,minmax(60px,1fr));grid-gap:15px}.icons mat-icon{font-size:60px;width:60px;height:60px;display:block;overflow:hidden;color:#555}\n"], components: [{ type: i3.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i3.MatPrefix, selector: "[matPrefix]" }, { type: i6.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["id", "disabled", "required", "type", "value", "readonly", "placeholder", "errorStateMatcher", "aria-describedby"], exportAs: ["matInput"] }, { type: i7.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i7.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i8.FsSkeletonContentDirective, selector: "[fsSkeleton]", inputs: ["fsSkeleton", "fsSkeletonPattern"] }, { type: i4$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i10.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { type: i1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }, { type: i1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["type", "mat-dialog-close", "aria-label", "matDialogClose"], exportAs: ["matDialogClose"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DialogComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-component',
                    templateUrl: 'dialog.component.html',
                    styleUrls: ['dialog.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i1.MatDialogRef }, { type: i0.ChangeDetectorRef }, { type: i2.FsClipboard }]; } });

class IconDialog {
    constructor(dialog) {
        this.dialog = dialog;
        this._destroy$ = new Subject();
    }
    open() {
        const dialogRef = this.dialog.open(DialogComponent, {
            width: '550px',
            data: {}
        });
        const subject = new Subject();
        const afterClose = dialogRef.afterClosed()
            .pipe(takeUntil(this._destroy$))
            .subscribe(result => {
            afterClose.unsubscribe();
            subject.next(result);
            subject.complete();
        });
        return subject;
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
}
IconDialog.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: IconDialog, deps: [{ token: i1.MatDialog }], target: i0.ɵɵFactoryTarget.Injectable });
IconDialog.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: IconDialog });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: IconDialog, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.MatDialog }]; } });

class FsIconPickerComponent {
    constructor(_dialog, _el, _cdRef) {
        this._dialog = _dialog;
        this._el = _el;
        this._cdRef = _cdRef;
        this.color = '';
        this.onChange = () => { };
        this.onTouch = () => { };
        this._destroy$ = new Subject();
    }
    inputClick($event) {
        if (!this.model) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        this.openDialog();
    }
    writeValue(value) {
        this._update(value);
        this._cdRef.markForCheck();
    }
    registerOnChange(_) { this.onChange = _; }
    registerOnTouched(_) { }
    ngAfterViewInit() {
        const element = this._el.nativeElement;
        element.setAttribute('readonly', 'readonly');
        element.parentElement.parentElement.insertBefore(element.firstChild, element.parentElement);
    }
    clear() {
        this.change(null);
    }
    openDialog() {
        const dialogRef = this._dialog.open(DialogComponent);
        dialogRef.afterClosed()
            .pipe(takeUntil(this._destroy$))
            .subscribe((value) => {
            if (value) {
                this.change(value);
            }
        });
    }
    change(value) {
        this._update(value);
        this.onChange(value);
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    _update(value) {
        this._el.nativeElement.value = value;
        this.model = value;
    }
}
FsIconPickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsIconPickerComponent, deps: [{ token: i1.MatDialog }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FsIconPickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsIconPickerComponent, selector: "[fsIconPicker]", inputs: { color: "color" }, host: { listeners: { "click": "inputClick($event)" } }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FsIconPickerComponent),
            multi: true
        }], ngImport: i0, template: `
    <div class="mat-form-field-suffix fs-icon-wrap" *ngIf="model" (click)="openDialog()"><mat-icon [ngStyle]="{ color: color }">{{model}}</mat-icon></div>
    <fs-clear (clear)="clear()" [show]="true" [visible]="!!model"></fs-clear>
  `, isInline: true, styles: [".fs-icon-wrap{margin-right:4px;cursor:pointer}:host{cursor:pointer}\n"], components: [{ type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i3$1.FsClearElementComponent, selector: "fs-clear", inputs: ["show", "visible"], outputs: ["clear"] }], directives: [{ type: i4$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsIconPickerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[fsIconPicker]',
                    template: `
    <div class="mat-form-field-suffix fs-icon-wrap" *ngIf="model" (click)="openDialog()"><mat-icon [ngStyle]="{ color: color }">{{model}}</mat-icon></div>
    <fs-clear (clear)="clear()" [show]="true" [visible]="!!model"></fs-clear>
  `,
                    styleUrls: ['./fs-icon-picker.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => FsIconPickerComponent),
                            multi: true
                        }],
                }]
        }], ctorParameters: function () { return [{ type: i1.MatDialog }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { color: [{
                type: Input
            }], inputClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class FsIconPickerModule {
    static forRoot() {
        return {
            ngModule: FsIconPickerModule,
            providers: [IconDialog]
        };
    }
}
FsIconPickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsIconPickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsIconPickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsIconPickerModule, declarations: [DialogComponent,
        FsIconPickerComponent], imports: [FormsModule,
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatTooltipModule,
        HttpClientJsonpModule,
        HttpClientModule,
        FsClearModule,
        FsSkeletonModule], exports: [DialogComponent,
        FsIconPickerComponent] });
FsIconPickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsIconPickerModule, providers: [
        IconDialog,
    ], imports: [[
            FormsModule,
            CommonModule,
            MatDialogModule,
            MatButtonModule,
            MatIconModule,
            MatInputModule,
            MatTooltipModule,
            HttpClientJsonpModule,
            HttpClientModule,
            FsClearModule,
            FsSkeletonModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsIconPickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormsModule,
                        CommonModule,
                        MatDialogModule,
                        MatButtonModule,
                        MatIconModule,
                        MatInputModule,
                        MatTooltipModule,
                        HttpClientJsonpModule,
                        HttpClientModule,
                        FsClearModule,
                        FsSkeletonModule,
                    ],
                    exports: [
                        DialogComponent,
                        FsIconPickerComponent
                    ],
                    entryComponents: [
                        DialogComponent
                    ],
                    declarations: [
                        DialogComponent,
                        FsIconPickerComponent
                    ],
                    providers: [
                        IconDialog,
                    ],
                }]
        }] });

/*
 * Public API Surface of fs-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DialogComponent, FsIconPickerComponent, FsIconPickerModule, IconDialog };
